<div class="wrapper wrapper-content animated fadeIn">
	<div class="row">
		<div class="col-lg-12">
			<div class="ibox float-e-margins">
				<div class="ibox-title">
					<h5>{{listing_config?.label||listing_config?.title||title|translate}}</h5>
					<div class="ibox-tools">
						<button *ngIf="listing_id" class="btn btn-default bg-muted btn-circle tig-mr6" (click)="goBack()" title="{{'back'|translate}}"><i class="fa fa-reply"></i></button>
						<button class="btn btn-default bg-muted btn-circle tig-mr6" (click)="reloadTableData()" title="{{'refresh'|translate}}"><i class="fa fa-refresh"></i></button>
						<button class="btn btn-primary btn-circle" (click)="createNewItem()" title="{{'new'|translate}}" *ngIf="listing_config.allowcreate"><i class="fa fa-plus"></i></button>
						<button class="btn btn-primary btn-circle" (click)="createBulkinsert()" title="{{'oBulkinsert.sBulkInsert'|translate}}" *ngIf="bulkinsert"><i class="fa  fa-th-list"></i></button>
					</div>
				</div>
				<div class="ibox-content">
					<div class="table-responsive">
						<div id="DataTables_Table_0_wrapper" class="dataTables_wrapper form-inline dt-bootstrap" *ngIf="table_show">
							<div *ngIf="notification" class="alert alert-info">
								{{notification | translate}}
							</div>
							<table datatable [dtOptions]="dt_options" class="table table-striped table-bordered hover" id="datatable" style="width:100%">
								<tfoot>
									<tr id="filterrow">
										<th *ngFor="let column of this.listing_config.columns; let i = index" [attr.data-index]="i"><input class="column-filter" *ngIf="column.filter === true" type="text" placeholder="{{ 'Suche ' + column.title }}" name="{{ 'search-' + column.data }}"/></th>
									</tr>
								</tfoot>
							</table>
						</div>
					</div>
					<div class="clear"></div>
				</div>
			</div>
		</div>
	</div>
</div>
